/// <reference types="@types/googlemaps" />
export class PulseOverlay {
  overLayView: google.maps.OverlayView;
  position_: google.maps.LatLng;
  map_: google.maps.Map;
  overlay_: HTMLDivElement;

  event = { onMove: function (val?) {} };
  constructor(private map: google.maps.Map) {
    this.overLayView = new google.maps.OverlayView();
    this.map_ = map;
    this.position_ = map.getCenter();
    // Explicitly call setMap on this overlay.
    this.overLayView.setMap(map);
  }

  /**
   * onAdd is called once when the map's panes and its projection have been initialized
   * Create new overlay and add to map
   */
  onAdd() {
    if (!this.overlay_) {
      this.overlay_ = document.createElement('div');

      if (this.overlay_.className !== 'pulse') {
        this.overlay_.className = 'pulse';
      }
      const panes = this.overLayView.getPanes();

      // insert overlay
      panes.overlayImage.appendChild(this.overlay_);
    }
  }

  /**
   * Use to draw or update the overlay. It is called after onAdd() and is called on
   * a change of zoom or recenter
   */
  draw() {
    const point = this.overLayView.getProjection(); // .fromLatLngToDivPixel(this.position_);
    if (point) {
      const p = point.fromLatLngToDivPixel(this.position_);
      this.overlay_.style.left = p.x + 'px';
      this.overlay_.style.top = p.y + 'px';
    }
  }

  /**
   *  The onRemove() method will be called automatically from the API if
   *  we ever set the overlay's map property to 'null'.
   */
  onRemove() {
    this.overlay_.parentNode.removeChild(this.overlay_);
    this.overlay_ = null;
  }

  /**
   * Remove the overlay from the map will trigger onRemove function
   */
  removePulse() {
    try {
      this.overLayView.setMap(null);
    } catch (error) {}
  }

  /**
   * Add the overlay from the map will trigger onAdd function
   */
  addPulse() {
    this.overLayView.setMap(this.map_);
  }

  showPulse() {
    if (this.overlay_) {
      this.overlay_.style.display = 'block';
    }
  }

  hidePulse() {
    if (this.overlay_) {
      this.overlay_.style.display = 'none';
    }
  }

  /**
   * Change the postion of the overlay and trigger draw to redraw overlay in new position
   */
  updateOverlayPosition(event?: any) {
    if (event.lat) {
      this.position_ = new google.maps.LatLng(event.lat, event.lng);
    } else {
      this.position_ = event.latLng;
    }
  }
}
